module.exports = __webpack_public_path__ + "img/edit.00be7bcd.svg";